module.exports = __webpack_public_path__ + "static/rekord-4e4023edcdf82c69ffc1952d9ec2cf4c.png";